import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PendoGuideStarterDirective } from './pendo-guide-starter.directive';

@NgModule({
  declarations: [PendoGuideStarterDirective],
  exports: [PendoGuideStarterDirective],
  imports: [CommonModule],
})
export class PendoGuideStarterModule {}
